<template>
  <div class="home">
    <div class="swipe-section">
      <div class="section_wrap panel">
        <div class="main_contain">
          <div class="wrap_title_boxs">
            <img class="banner_logo" src="@/assets/img/logo_white.png" alt="" />
            <div class="wrap_title">更智能的眼科信息化平台</div>
            <div class="wrap_tip">
              -Smarter Ophthalmic Informatics Platform-
            </div>
          </div>
        </div>
      </div>

      <div class="section_b1 panel">
        <div class="main_contain">
          <div class="platform_boxs">
            <div class="platform_item" @mouseover="goToSlide(0)">
              <img
                v-show="currentSwiperIndex === 0"
                class="platform_item_img"
                src="@/assets/img/icon_nor2.png"
                alt=""
              />
              <img
                v-show="currentSwiperIndex !== 0"
                class="platform_item_img"
                src="@/assets/img/icon_nor2_w.png"
                alt=""
              />
              <div class="platform_item_text_box">
                <div class="platform_item_text_cn">医生端</div>
                <div class="platform_item_text_en">for hospital</div>
              </div>
            </div>
            <div class="platform_item" @mouseover="goToSlide(1)">
              <img
                v-show="currentSwiperIndex === 1"
                class="platform_item_img"
                src="@/assets/img/icon_nor4.png"
                alt=""
              />
              <img
                v-show="currentSwiperIndex !== 1"
                class="platform_item_img"
                src="@/assets/img/icon_nor4_w.png"
                alt=""
              />
              <div class="platform_item_text_box">
                <div class="platform_item_text_cn">供应链端</div>
                <div class="platform_item_text_en">for Supply Chain</div>
              </div>
            </div>
            <div class="platform_item" @mouseover="goToSlide(2)">
              <img
                v-show="currentSwiperIndex === 2"
                class="platform_item_img"
                src="@/assets/img/icon_nor3.png"
                alt=""
              />
              <img
                v-show="currentSwiperIndex !== 2"
                class="platform_item_img"
                src="@/assets/img/icon_nor3_w.png"
                alt=""
              />
              <div class="platform_item_text_box">
                <div class="platform_item_text_cn">厂家端</div>
                <div class="platform_item_text_en">for manufacturer</div>
              </div>
            </div>
            <div class="platform_item" @mouseover="goToSlide(3)">
              <img
                v-show="currentSwiperIndex === 3"
                class="platform_item_img"
                src="@/assets/img/icon_nor1.png"
                alt=""
              />
              <img
                v-show="currentSwiperIndex !== 3"
                class="platform_item_img"
                src="@/assets/img/icon_nor1_w.png"
                alt=""
              />
              <div class="platform_item_text_box">
                <div class="platform_item_text_cn">患者端</div>
                <div class="platform_item_text_en">for patient</div>
              </div>
            </div>
            <div class="platform_item" @mouseover="goToSlide(4)">
              <img
                v-show="currentSwiperIndex === 4"
                class="platform_item_img"
                src="@/assets/img/icon_nor5.png"
                alt=""
              />
              <img
                v-show="currentSwiperIndex !== 4"
                class="platform_item_img"
                src="@/assets/img/icon_nor5_w.png"
                alt=""
              />
              <div class="platform_item_text_box">
                <div class="platform_item_text_cn">用户体验地图</div>
                <div class="platform_item_text_en">User Experience Map</div>
              </div>
            </div>
          </div>
          <swiper
            class="swiper_section"
            :slides-per-view="1"
            :space-between="0"
            @swiper="onSwiper"
            @slideChange="onSlideChange"
          >
            <swiper-slide>
              <div class="swiper_box_item">
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">眼科门诊电子病历系统 (EMR)</div>
                  <p class="swiper_box1_p">· 电子病历管理</p>
                  <p class="swiper_box1_p">· 院内业务无纸化、协同化</p>
                  <p class="swiper_box1_p">· 实现合规与信息安全</p>
                </div>
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">影像管理分析系统 (PACS)</div>
                  <p class="swiper_box1_p">
                    · 内置多种眼科影像，支持影智能归类
                  </p>
                  <p class="swiper_box1_p">· 关键影像数据自动识别</p>
                  <p class="swiper_box1_p">· 支持与眼科设备连接，</p>
                  <p class="swiper_box1_p">· 自动同步影像搛鈎削懦据</p>
                </div>
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">眼科手术管理系统 (RSC)</div>
                  <p class="swiper_box1_p">· 排班高效便捷</p>
                  <p class="swiper_box1_p">· 批量安排手术名单</p>
                  <p class="swiper_box1_p">· 自动与患者协商手术时间</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper_box_item" style="width: 438px">
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">数字化供应链系统</div>
                  <p class="swiper_box1_p">· 智能在线订购</p>
                  <p class="swiper_box1_p">· 透明物流跟踪</p>
                  <p class="swiper_box1_p">· 实时库存管理</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper_box_item" style="width: 438px">
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">患者宣教与交流平台</div>
                  <p class="swiper_box1_p">· 了解眼科权威信息</p>
                  <p class="swiper_box1_p">· 查看患者就医点评</p>
                  <p class="swiper_box1_p">· 患者交流社区</p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper_box_item" style="width: fit-content">
                <div class="swiper_box1_f1">
                  <div class="swiper_box1_t1">全链路数据采集与分析</div>
                  <p class="swiper_box1_p">
                    · 制定更加精准的医院管理和个性化营销方案
                  </p>
                  <p class="swiper_box1_p">
                    · 提升屈光手术的安全性、稳定性和患者满意度
                  </p>
                </div>
                <div class="swiper_box1_f1">
                  <img
                    class="swiper_box1_f1_img"
                    src="@/assets/img/swiper_img.png"
                    alt=""
                  />
                </div>
              </div>
            </swiper-slide>
            <swiper-slide>
              <div class="swiper_box_item" style="width: fit-content">
                <div class="swiper_box1_f2">
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon1.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">了解近视矫正手术</div>
                  </div>
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon2.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">选择医院</div>
                  </div>
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon3.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">挂号到院</div>
                  </div>
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon4.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">预定耗材</div>
                  </div>
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon5.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">手术预约</div>
                  </div>
                  <div class="swiper_box1_icon_item">
                    <img
                      class="swiper_box1_icon_img"
                      src="@/assets/img/swiper_icon6.png"
                      alt=""
                    />
                    <div class="swiper_box1_icon_text">术后随访</div>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>

      <div class="section_b2 panel">
        <div class="section_b2_top"></div>
        <div class="section_b2_bottom">
          <div class="main_contain">
            <div class="b2_tboxs">
              <div class="b2_title">信息安全</div>
              <div class="b2_main_boxs">
                <div class="b2_main_item">
                  <div class="b2_main_item_t">数据私隐保护</div>
                  <div class="b2_main_item_content">
                    严格遵守相关法律法规，采取安全的数据存储和传输技术，确保用户个人信息和医疗数据的隐私和安全。通过加密技术、访问权限控制等手段来防止未经授权的访问或泄露。
                  </div>
                </div>

                <div class="b2_main_item">
                  <div class="b2_main_item_t">防止欺诈和滥用</div>
                  <div class="b2_main_item_content">
                    平台设有风险监测和反欺诈机制，通过数据分析和算法监控异常活动和可疑行为，以及对用户提交信息的验证和核实，从而防止欺诈和滥用情况的发生。
                  </div>
                </div>

                <div class="b2_main_item">
                  <div class="b2_main_item_t">安全认证和合规</div>
                  <div class="b2_main_item_content">
                    平台与专业的安全机构合作，进行安全审计和认证，确保产品符合行业标准和最佳实践。同时，积极响应并遵循相关的法规和合规要求，例如个人信息保护法、医疗健康数据管理规定等并取得安全等级保护三级认证。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b3 panel">
        <div class="section_b3_top"></div>
        <div class="section_b3_bottom">
          <div class="main_contain">
            <div class="b3_tboxs">
              <div class="b3_title">关于我们</div>
              <div class="b3_content">
                <span>广州有济于世信息科技有限公司</span
                >，是一家专门从事眼科信息化解决方案的专业软件公司。公司致力于为眼科业务提供全流程信息化、数字化、智能化的解决方案。公司自主研发眼科信息化平台，采用人工智能，大数据分析等业内先进技术，支持定制化嵌入客户的终端系统，为智能化医疗赋能助力。
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b4 panel">
        <div class="section_b4_top"></div>
        <div class="section_b4_cneter">
          <div class="main_contain">
            <div class="b4_boxs">
              <div class="b4_boxs_left">
                <div id="allmap"></div>
              </div>

              <div class="b4_boxs_right">
                <div class="b4_right_tboxs">
                  <div class="b4_r_title">留言</div>
                  <div class="b4_r_tip">
                    填写你的大概信息，我们会及时安排业务专员和您联系!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b5 panel">
        <div class="main_contain">
          <div class="b5_boxs">
            <div class="b5_title">招纳贤士</div>
            <div class="b5_tip">
              <img
                class="icon_boder_l"
                src="@/assets/img/icon_border.png"
                alt=""
              />
              投递岗位,请将简历发送到: 邮箱 info@gigitech.cn,
              邮件标题为:岗位+姓名
              <img
                class="icon_boder_r"
                src="@/assets/img/icon_border.png"
                alt=""
              />
            </div>

            <div class="b5_content_bs">
              <div class="b5_bs_item">
                <div class="b5_bs_item_title">产品经理 / Products Manager</div>
                <p class="b5_bs_item_p">• 广州, 全职</p>
                <p class="b5_bs_item_p">
                  • 对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
              <div class="b5_bs_item">
                <div class="b5_bs_item_title">产品经理 / Products Manager</div>
                <p class="b5_bs_item_p">• 广州, 全职</p>
                <p class="b5_bs_item_p">
                  • 对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
              <div class="b5_bs_item">
                <div class="b5_bs_item_title">产品经理 / Products Manager</div>
                <p class="b5_bs_item_p">• 广州, 全职</p>
                <p class="b5_bs_item_p">
                  • 对产品整体规划、设计、优化和推广的专业人员
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section_b6 panel">
        <div class="main_contain">
          <div class="b6_boxs">
            <div class="b6_title">信息安全</div>
            <div class="b6_main_bs">
              <div class="b6_main_item">
                <div class="b6_main_item_t">—————— 医生端 ——————</div>
                <div class="b6_main_item_download"></div>
              </div>
              <div class="b6_main_item">
                <div class="b6_main_item_t">—————— 患者端 ——————</div>
                <div class="b6_main_item_download"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container horizontal"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from "vue";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";

const currentSwiperIndex = ref(0);

const onSwiper = (swiper) => {
  mySwiper.value = swiper;
};

const onSlideChange = (swiper) => {
  currentSwiperIndex.value = swiper.activeIndex;
};
const mySwiper = ref();
const goToSlide = (index) => {
  mySwiper.value.slideTo(index);
  currentSwiperIndex.value = index;
};

const initMap = () => {
  if (window.BMapGL) {
    const map = new window.BMapGL.Map("allmap"); // 创建地图实例
    const point = new window.BMapGL.Point(116.404, 39.915); // 设置中心点坐标
    map.centerAndZoom(point, 16); // 初始化地图，设置中心点坐标和地图级别
    map.disableScrollWheelZoom(); // 开启鼠标滚轮缩放

    const geocoder = new window.BMapGL.Geocoder();
    // 要显示的地址
    const address = "广州市珠江新城兴民路222号天盈广场西塔1905室";

    const getCoordinates = (address) => {
      geocoder.getPoint(
        address,
        (point) => {
          if (point) {
            // 设置地图中心点
            map.centerAndZoom(point, 16);

            // 添加标记
            const marker = new window.BMapGL.Marker(point);
            map.addOverlay(marker);

            // 添加信息窗口
            const infoWindow = new window.BMapGL.InfoWindow(address);
            marker.addEventListener("click", () => {
              map.openInfoWindow(infoWindow, point);
            });

            // 使用 geocoder.getLocation 获取详细的地理编码信息
            geocoder.getLocation(point, (result) => {
              if (result) {
                // 返回详细的地理编码信息，包含地址、省市区等

                // 创建信息窗口内容
                const infoContent = `<div class="company_boxs"> 
                <div class="company_bb"><div class="company_label">联系电话：</div>020-123 3456 7899</div>
                <div class="company_bb"><div class="company_label">邮箱：</div>info@gigitech.cn</div>
                <div class="company_bb"><div class="company_label">详细地址：</div>${address}</div></div> `;

                // 创建信息窗口
                const infoWindow = new window.BMapGL.InfoWindow(infoContent, {
                  width: 300, // 固定宽度
                  height: 0,
                  offset: new window.BMapGL.Size(0, -20), // 调整位置偏移（可选）
                  title: "联系方式",
                });

                // 在地图加载时直接展示信息窗口
                map.openInfoWindow(infoWindow, point);

                // 添加标记点击事件
                marker.addEventListener("click", () => {
                  map.openInfoWindow(infoWindow, point);
                });
              }
            });
          } else {
            console.error("无法解析地址：" + address);
          }
        },
        "广州市" // 可选：指定城市以提高解析精度
      );
    };

    getCoordinates(address);
  }
};

const initGsap = () => {
  const container = document.querySelector(".swipe-section");
  const panels = gsap.utils.toArray(".panel"); // 获取所有 panel 元素
  console.log("panels", panels);
  const panelNum = panels.length;
  let panelIncrement = 1 / (panelNum - 1);
  const endValue = () => container.scrollHeight - window.innerHeight;
  ScrollTrigger.create({
    trigger: container,
    start: "top top",
    end: () => endValue,
    snap: {
      snapTo: panelIncrement,
      duration: { min: 0.3, max: 0.6 },
      ease: "power1.inOut",
    },
  });
};

onMounted(() => {
  nextTick(() => {
    initMap();
    initGsap();
  });
});
</script>

<style lang="scss" scoped>
.home {
  .swipe-section {
    width: 100%;
  }
  .section_wrap {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner2.jpg") no-repeat center/cover;
    .wrap_title_boxs {
      padding-top: 360px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .banner_logo {
        height: 100px;
        margin-bottom: 16px;
      }

      .wrap_title {
        font-size: 50px;
        color: #fff;
        letter-spacing: 15px;
      }

      .wrap_tip {
        width: fit-content;
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        margin-top: 2px;
        letter-spacing: 1px;
        padding: 8px 40px;
        border-radius: 20px;
        background: rgb(212 30 109 / 80%);
        margin-top: 30px;
        line-height: 1.2;
      }
    }
  }

  .section_b1 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner5.jpg") no-repeat center/cover;

    .platform_boxs {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 258px;
      margin-bottom: 40px;
      .platform_item {
        margin: 0 50px;
        color: #fff;

        .platform_item_img {
          height: 134px;
          transition: all 0.2s ease-in;
        }
        .platform_item_text_box {
          margin-top: 20px;
          .platform_item_text_cn {
            font-size: 21px;
            letter-spacing: 2px;
          }
          .platform_item_text_en {
            margin-top: 4px;
            font-size: 16px;
          }
        }
      }
    }

    .swiper_section {
      .swiper-slide {
        display: flex;
        justify-content: center;
      }
    }

    .swiper_box_item {
      width: 1153px;
      height: 294px;
      border-radius: 20px;
      background: rgba($color: #d41e6d, $alpha: 0.8);
      color: #fff;
      display: flex;
      padding: 30px;
      .swiper_box1_f1 {
        width: 351px;
        text-align: left;
        margin-right: 80px;

        &:last-child {
          margin-right: 0px;
        }

        .swiper_box1_t1 {
          width: 100%;
          font-size: 21px;
          padding-bottom: 15px;
          border-bottom: 1px solid #fff;
          margin-bottom: 20px;
          letter-spacing: 2px;
        }

        .swiper_box1_p {
          font-size: 16px;
          letter-spacing: 2px;
        }
        .swiper_box1_f1_img {
          width: 344px;
        }

        .swiper_box1_icon_item {
          .swiper_box1_icon_img {
            width: 118px;
          }
        }
      }

      .swiper_box1_f2 {
        display: flex;
        .swiper_box1_icon_item {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 0 30px;
          .swiper_box1_icon_img {
            width: 118px;
            margin-bottom: 20px;
          }
        }
      }
    }
  }

  .section_b2 {
    height: 100vh;
    .section_b2_top {
      height: 570px;
      width: 100%;
      background: url("@/assets/img/banner6.jpg") no-repeat center/cover;
    }
    .section_b2_bottom {
      height: calc(100vh - 570px);
      width: 100%;
      background: #29a69c;
      padding-top: 30px;

      .b2_tboxs {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .b2_title {
        font-size: 21px;
        padding: 10px 50px;
        background: #d41e6d;
        color: #fff;
        border-radius: 30px;
        width: fit-content;
        margin-bottom: 30px;
        letter-spacing: 2px;
        line-height: 1.2;
      }

      .b2_main_boxs {
        display: flex;
        justify-content: center;
        color: #fff;
        width: 100%;
        .b2_main_item {
          margin-right: 92px;
          width: 428px;
          letter-spacing: 2px;
          &:last-child {
            margin-right: 0;
          }

          .b2_main_item_t {
            padding-bottom: 12px;
            margin-bottom: 9px;
            border-bottom: 1px solid #fff;
            font-size: 21px;
            letter-spacing: 2px;
          }

          .b2_main_item_content {
            font-size: 18px;
            line-height: 34px;
          }
        }
      }
    }
  }

  .section_b3 {
    height: 100vh;
    .section_b3_top {
      height: 570px;
      width: 100%;
      background: url("@/assets/img/banner7.jpg") no-repeat center/cover;
    }

    .section_b3_bottom {
      height: calc(100vh - 570px);
      width: 100%;
      background: #29a69c;
      padding-top: 30px;
      .b3_tboxs {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .b3_title {
        font-size: 21px;
        padding: 10px 50px;
        background: #d41e6d;
        color: #fff;
        border-radius: 30px;
        width: fit-content;
        margin-bottom: 30px;
        letter-spacing: 2px;
        line-height: 1.2;
      }

      .b3_content {
        font-size: 20px;
        width: 930px;
        line-height: 34px;
        color: #fff;
        letter-spacing: 2px;
        font-weight: 400;
        span {
          font-size: 23px;
          font-weight: 600;
        }
      }
    }
  }

  .section_b4 {
    .section_b4_top {
      height: 570px;
      width: 100%;
      background: url("@/assets/img/banner3.jpg") no-repeat center/cover;
    }
    .section_b4_cneter {
      width: 100%;
      height: calc(100vh - 570px);
      background: #29a69c;
      .main_contain {
        height: 100%;
      }
      .b4_boxs {
        display: flex;
        height: 100%;
        padding: 20px;

        .b4_boxs_right {
          width: 50%;
          display: flex;
          flex-direction: column;
          padding: 30px;

          .b4_right_tboxs {
            display: flex;
            margin-bottom: 30px;
            .b4_r_title {
              font-size: 21px;
              padding: 10px 30px;
              background: #d41e6d;
              color: #fff;
              border-radius: 30px;
              width: fit-content;
            }
            .b4_r_tip {
              margin-left: 4px;
              font-size: 21px;
              padding: 10px 30px;
              background: rgba($color: #003537, $alpha: 0.2);
              color: #fff;
              border-radius: 30px;
              width: fit-content;
            }
          }
        }

        .b4_boxs_left {
          width: 50%;
          height: 100%;
          border: 2px dashed #fff;
          border-radius: 10px;
          padding: 4px;
          #allmap {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
        }
      }
    }
    .section_b4_bottom {
      width: 100%;
      height: 660px;
    }
  }

  .section_b5 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner4.jpg") no-repeat center/cover;
    padding-top: 226px;
    .b5_boxs {
      width: 1200px;
      height: 600px;
      background: rgba($color: #003639, $alpha: 0.4);
      margin: 0 auto;
      padding: 70px 95px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      .b5_title {
        font-size: 21px;
        padding: 10px 50px;
        background: #d41e6d;
        color: #fff;
        border-radius: 30px;
        margin-bottom: 30px;
        line-height: 1.2;
        letter-spacing: 2px;
      }

      .b5_tip {
        height: 44px;
        line-height: 44px;
        background: rgba($color: #003639, $alpha: 0.2);
        color: #fff;
        letter-spacing: 2px;
        font-size: 21px;
        text-align: center;
        padding: 0 20px;
        position: relative;
        font-weight: 400;

        .icon_boder_l {
          position: absolute;
          left: 0;
          top: 0;
          width: 17px;
        }
        .icon_boder_r {
          position: absolute;
          right: 0;
          bottom: 0;
          width: 17px;
          transform: scale(-1);
        }
      }

      .b5_content_bs {
        display: flex;
        align-items: center;
        margin-top: 40px;

        .b5_bs_item {
          width: 280px;
          height: 200px;
          padding: 30px;
          background: rgba($color: #29a69c, $alpha: 0.8);
          border-radius: 25px;
          color: #fff;
          margin: 0 36px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          font-size: 16px;
          text-align: left;
          font-weight: 300;

          .b5_bs_item_title {
            padding-bottom: 10px;
            width: 100%;
            border-bottom: 1px solid #fff;
            margin-bottom: 10px;
          }

          .b5_bs_item_p {
            margin: 6px 0;
            font-size: 16px;
          }
        }
      }
    }
  }

  .section_b6 {
    height: 100vh;
    width: 100%;
    background: url("@/assets/img/banner1.jpg") no-repeat center/cover;
    padding-top: 226px;
    .b6_boxs {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;

      .b6_title {
        font-size: 21px;
        padding: 10px 50px;
        background: #d41e6d;
        color: #fff;
        border-radius: 30px;
        margin-bottom: 30px;
        line-height: 1.2;
        letter-spacing: 2px;
      }

      .b6_main_bs {
        display: flex;
        justify-content: center;
        margin-top: 40px;
        .b6_main_item {
          margin: 0 100px;

          .b6_main_item_t {
            color: #fff;
            font-size: 21px;
            margin-bottom: 40px;
          }
        }
      }
    }
  }
}
</style>
